import { Component, OnInit } from '@angular/core';
import { BrokerTabsService, Tab } from '../../services/broker-tabs.service';
import { CommonModule } from '@angular/common';
import { Overview } from '../broker-tabs-Components/overview/overview';
import { CrmDashboard } from '../broker-tabs-Components/crm-dashboard/crm-dashboard';
import { Calendar } from '../broker-tabs-Components/calendar/calendar';
import { Marketing } from '../broker-tabs-Components/marketing/marketing';
import { Commissions } from '../broker-tabs-Components/commissions/commissions';
import { BrokerProfile } from '../broker-tabs-Components/profile/profile';
import { BrokerSettings } from '../broker-tabs-Components/settings/settings';
import { Projects } from '../broker-tabs-Components/projects/projects';
import { BrokerUnits } from '../broker-tabs-Components/units/units';
import { Offers } from '../broker-tabs-Components/offers/offers';
import { StaffDashboardComponent } from '../broker-tabs-Components/staff/staff-dashboard.component';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';

@Component({
  selector: 'app-broker-tabs-content',
  standalone: true,
  imports: [
    CommonModule,
    Overview,
    CrmDashboard,
    Calendar,
    Marketing,
    Commissions,
    BrokerProfile,
    BrokerSettings,
    Projects,
    BrokerUnits,
    Offers,
    StaffDashboardComponent,
  ],
  templateUrl: './broker-tabs-content.html',
  styleUrl: './broker-tabs-content.scss',
  animations: [
    trigger('tabAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(10px)' })),
      ]),
    ]),
    trigger('contentAnimation', [
      transition('* => *', [
        query(
          ':enter',
          [
            style({ opacity: 0, transform: 'translateY(10px)' }),
            stagger('100ms', [
              animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
            ]),
          ],
          { optional: true },
        ),
        query(
          ':leave',
          [animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(10px)' }))],
          { optional: true },
        ),
      ]),
    ]),
  ],
})
export class BrokerTabsContent implements OnInit {
  activeTab: string = '';
  tabs: Tab[] = [];
  previousTab: string = '';

  constructor(private tabsService: BrokerTabsService) {}

  ngOnInit(): void {
    this.tabs = this.tabsService.getTabs();
    this.activeTab = this.tabsService.getActiveTab();

    this.tabsService.activeTab$.subscribe((tabId) => {
      this.previousTab = this.activeTab;
      this.activeTab = tabId;
    });
  }

  isActiveTab(tabId: string): boolean {
    return this.activeTab === tabId;
  }

  getComponentForTab(tabId: string): any {
    // Import components dynamically based on tab ID
    switch (tabId) {
      case 'overview':
        return import('../broker-tabs-Components/overview/overview').then((m) => m.Overview);
      case 'crm-dashboard':
        return import('../broker-tabs-Components/crm-dashboard/crm-dashboard').then(
          (m) => m.CrmDashboard,
        );
      case 'calendar':
        return import('../broker-tabs-Components/calendar/calendar').then((m) => m.Calendar);
      case 'marketing':
        return import('../broker-tabs-Components/marketing/marketing').then((m) => m.Marketing);
      case 'commissions':
        return import('../broker-tabs-Components/commissions/commissions').then(
          (m) => m.Commissions,
        );
      case 'projects':
        return import('../broker-tabs-Components/projects/projects').then((m) => m.Projects);
      case 'staff':
        return import('../broker-tabs-Components/staff/staff-dashboard.component').then(
          (m) => m.StaffDashboardComponent,
        );
      default:
        return null;
    }
  }
}
